import { render } from "./EmailSettingsPanel.vue?vue&type=template&id=167a5273"
import script from "./EmailSettingsPanel.vue?vue&type=script&lang=ts"
export * from "./EmailSettingsPanel.vue?vue&type=script&lang=ts"
script.render = render

export default script